import { goTo, goToBlank } from '../window/location'

export const goToServiceAppointmentLogbook = (id: string, blank = false) => {
  const destination = `/lab-book/service-appointment/?reservation=${id}`
  blank ? goToBlank(destination) : goTo(destination)
}

export const goToEquipmentLogbook = (id: string, blank = false) => {
  const destination = `/lab-book/equipment/?equipment[]=${id}`

  blank ? goToBlank(destination) : goTo(destination)
}
